import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/node/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/node/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { _registerNode } from '../Global.js';
import { Util } from '../Util.js';
import { getNumberOrArrayOfNumbersValidator } from '../Validators.js';
export var Rect = /*#__PURE__*/function (_Shape) {
  _inherits(Rect, _Shape);
  var _super = _createSuper(Rect);
  function Rect() {
    _classCallCheck(this, Rect);
    return _super.apply(this, arguments);
  }
  _createClass(Rect, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var cornerRadius = this.cornerRadius(),
        width = this.width(),
        height = this.height();
      context.beginPath();
      if (!cornerRadius) {
        context.rect(0, 0, width, height);
      } else {
        Util.drawRoundedRectPath(context, width, height, cornerRadius);
      }
      context.closePath();
      context.fillStrokeShape(this);
    }
  }]);
  return Rect;
}(Shape);
Rect.prototype.className = 'Rect';
_registerNode(Rect);
Factory.addGetterSetter(Rect, 'cornerRadius', 0, getNumberOrArrayOfNumbersValidator(4));